<template>
  <div class="order_list" id="orderlist" v-loading="loading">
    <template v-if="batchPayBtn">
      <div v-if="!home" class="batch_pay">
        <el-checkbox
          class="checkbox"
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        ><span v-if="multipleSelection.length">{{
          multipleSelection.length
        }}</span
        ><el-button class="batch_pay_btn" @click="batchPay">批量支付</el-button>
      </div>
    </template>
    <div class="commodity">
      <div
        class="commodity_label"
        :class="{ refundrow: orderItems.refund }"
        v-show="orderItems.total != 0"
      >
        <div class="com_tab com_info">商品信息</div>
        <div class="com_tab com_type">服务类型</div>
        <div class="com_tab com_contacts">客户信息</div>
        <div class="com_tab com_operation">
          {{ orderItems.refund ? "审核人" : "师傅信息" }}
        </div>
        <div class="com_tab com_money">
          {{ orderItems.refund ? "退款金额" : "支付金额" }}
        </div>
        <div class="com_tab com_money" v-if="orderItems.refund">实际退款</div>
        <div class="com_tab com_state">订单状态</div>
        <div class="com_tab com_order">订单操作</div>
      </div>
      <div class="commodity_info">
        <div class="null" v-show="orderItems.total == 0">
          <img src="../../assets/img/pic_none.png" alt />
          <div>没有搜索到相关数据…</div>
        </div>
        <div
          class="com_item"
          v-for="(item, index) in orderItems.rows"
          :key="index"
        >
          <div class="com_order_num checkbox">
            <el-checkbox
              v-if="batchPayBtn"
              :label="1"
              @change="checkOrder(item)"
              v-model="item.checked"
              class="ochenck"
            ></el-checkbox>
            {{ item.createTime }}
            <span style="cursor: pointer" @click="openOrderInfo(item)"
              >订单号：{{ item.orderNo }}</span
            >
            <div
              class="write_off"
              v-if="item.verifType && item.verifType != 'NOT'"
            >
              核销单
            </div>
            <!-- <div class="work-info" v-if="item.workerName">
              师傅：{{ item.workerName }}（{{ item.workerPhone }}）
            </div> -->
            <div class="yichang">
              <div v-if="item.appointmentTime">
                预约：{{
                  new Date(item.appointmentTime).format("yyyy-MM-dd") || "/"
                }}
              </div>
              <div v-if="item.orderExpand&&item.orderExpand.appointResult=='FAIL'">{{'预约：'+item.orderExpand.appointFailReason||'/'}}</div>
              <div v-if="item.isGoodsAbnormal">未处理异常<span>1</span></div>
              <div v-if="item.markupRequestTotal">
                加价申请<span>￥{{ item.markupRequestTotal }}</span>
              </div>
            </div>
            <div class="yichang">

            </div>
            <div class="label_tuikuan" v-if="item.refundStatusName">
              <i class="el-icon-warning-outline"></i>{{ item.refundStatusName }}
            </div>
          </div>
          <div class="com_data" :class="{ refundrow: orderItems.refund }">
            <div class="com_info" v-if="!!item.orderItems">
              <div class="img_content" v-if="item.orderItems.length == 1">
                <div class="imgs">
                  <img :src="item.orderItems[0].imgUrl" alt />
                  <div class="count">x{{ item.orderItems[0].count }}</div>
                </div>

                <span>{{ item.orderItems[0].name }}</span>
              </div>
              <div class="img_content" v-if="item.orderItems.length > 1">
                <div
                  class="imgs"
                  v-for="(it, ind) in item.orderItems"
                  :key="ind"
                >
                  <img :src="it.imgUrl" v-if="home ? ind <= 1 : ind <= 2" alt />
                  <div class="count">x{{ it.count }}</div>
                </div>
              </div>
            </div>
            <div class="com_type two_row">
              {{ item.goodsTypeName }}
              <br />
              {{ item.serviceTypeName }}
            </div>
            <div class="com_contacts two_row contacts_info">
              <div class="td_text">
                {{ item.customerName }}
                <!-- {{ orderItems.refund ? item.customerName : item.contactName }} -->
              </div>
              <!-- <br /> -->
              <div class="td_text">
                <!-- {{ orderItems.refund ? item.customerPhone : item.contactPhone }} -->
                {{ item.customerPhone }}
              </div>

              <div class="kehu_address" v-if="!item.refundNo">
                <span v-if="item.address.includes(item.provinceName)">{{
                  item.address
                }}</span>
                <span v-else>
                  {{
                    item.provinceName +
                    item.cityName +
                    item.areaName +
                    item.address
                  }}
                </span>
              </div>
              <div class="kehu_address" v-else>
                <span>{{ item.address }}</span>
              </div>
            </div>
            <div
              class="
                com_operation com_refund com_border
                two_row
                com_state_box
                state_three_row
                contacts_info
              "
            >
              <template v-if="!orderItems.refund">
                <template v-if="item.orderType == 'TIMELY'">
                  <!-- <div class="td_text">{{ item.workerName }}</div>
                <div class="td_text">
                  {{ item.workerPhone }}
                </div> -->
                  <div>聚师傅</div>
                  <el-button class="video_call" @click="isVideoCall(item)"
                    >站内电话</el-button
                  >
                </template>
                <div v-else>
                  <div>{{ item.workerName }}</div>
                  <div>{{ item.workerPhone }}</div>
                  <el-button
                    v-if="item.workerName"
                    class="video_call"
                    @click="isVideoCall(item)"
                    >站内电话</el-button
                  >
                  <div v-else>/</div>
                </div>
              </template>
              <template v-if="orderItems.refund">
                <div>{{ item.verifyWorkerName }}</div>
                <!-- <div>{{ item.verifyWorkerPhone }}</div> -->
                <el-button
                  v-if="item.verifyWorkerName"
                  class="video_call"
                  @click="isVideoCall(item)"
                  >站内电话</el-button
                >
              </template>
              <!-- <template v-if="!orderItems.refund">
                <div
                  class="com_state_abnormal"
                  style="color: #3455d3; cursor: pointer"
                  v-if="item.isGoodsAbnormal && !item.solveExceptionWay"
                  @click="abnormalInfo(item)"
                >
                  查看异常
                </div>
                <div
                  class="com_state_box_info"
                  v-if="
                    item.status == 'WAIT_PAY' ||
                    item.status == 'SUCCESS' ||
                    item.status == 'CLOSE' ||
                    item.status == 'EVALUATED'
                  "
                >
                  /
                </div>
                <div
                  class="com_state_box_info"
                  v-if="
                    item.status != 'WAIT_PAY' &&
                    item.status != 'SUCCESS' &&
                    item.status != 'CLOSE' &&
                    item.status != 'EVALUATED' &&
                    !orderItems.refund
                  "
                  @click="openRefund(item)"
                >
                  退款
                </div>
                <div
                  class="com_state_box_info"
                  v-if="
                    item.status == 'WAIT_PICK_UP' ||
                    item.status == 'WAIT_INSTALL' ||
                    item.status == 'WAIT_COMPLETE' ||
                    item.status == 'WAIT_VERIF' ||
                    item.status == 'WAIT_ACCEPT' ||
                    item.status == 'RECEIVING_ORDER'
                  "
                  @click="complaintCheck(item, index)"
                >
                  投诉
                </div>
              </template>
              <template v-if="orderItems.refund">
                <div
                  class="com_state_box_info"
                  v-if="
                    item.status != 'SUCCESS' &&
                    item.status != 'PROCESSED' &&
                    item.status != 'AGREE'
                  "
                  @click="openOrderInfo(item)"
                >
                  退款详情
                </div>
                <div
                  class="com_state_box_info blue"
                  v-else
                  @click="openOrderInfo(item)"
                >
                  <svg class="icon chakantui" aria-hidden="true">
                    <use xlink:href="#iconicon_tuikuan" /></svg
                  >查看退款
                </div>
              </template> -->
            </div>
            <div class="com_money com_price com_border" style="font-size: 13px">
              <template v-if="!orderItems.refund">
                ¥{{ item.totalAmount }}
              </template>
              <template v-if="orderItems.refund">
                ¥{{ item.applyRefundAmount || item.refundAmount }}
              </template>
            </div>

            <div
              class="com_tab com_price com_money"
              style="font-size: 13px"
              v-if="orderItems.refund"
            >
              ¥{{ item.refundAmount || 0 }}
            </div>
            <div
              class="com_state com_border two_row com_state_box state_three_row"
            >
              <template v-if="!orderItems.refund">
                <div class="state_text">
                  {{
                    item.statusName == "订单完成"
                      ? "交易成功"
                      : item.statusName == "已评价"
                      ? "交易成功"
                      : item.statusName == "订单关闭"
                      ? "交易关闭"
                      : item.statusName
                  }}
                </div>
                <!-- <div class="com_state_abnormal" v-if="item.childOrder"> -->
                <div
                  style="color: #909399"
                  v-if="item.childOrder && item.childOrder.status"
                >
                  {{ setStatus(item.childOrder.status) }}
                </div>
              </template>
              <template v-if="orderItems.refund">
                <div class="state_text" v-if="item.status == 'WAIT'">
                  审核中
                </div>
                <div class="state_text" v-if="item.status == 'ARBITRATION'">
                  退款维权中
                </div>
                <div
                  class="state_text"
                  v-if="
                    item.status == 'CANCEL' ||
                    item.status == 'ARBITRATION_CANCEL'
                  "
                >
                  退款取消
                </div>
                <div
                  class="state_text"
                  v-if="
                    item.status == 'SUCCESS' ||
                    item.status == 'PROCESSED' ||
                    item.status == 'AGREE'
                  "
                >
                  退款成功
                </div>
                <div class="state_text" v-if="item.status == 'REFUSE'">
                  退款拒绝
                </div>
                <!-- <div
                  class="com_state_box_info"
                  v-if="item.status != 'WAIT'"
                  @click="openOrderInfo(item)"
                >
                  订单详情
                </div> -->
                <div
                  class="com_state_box_info"
                  v-if="
                    item.status == 'ARBITRATION' || item.status == 'PROCESSED'
                  "
                  @click="arbitrationDetail(item)"
                >
                  仲裁详情
                </div>
                <div class="com_state_box_info" v-if="item.status == 'WAIT'">
                  {{ item.expirationTimeStr }}
                </div>
              </template>
            </div>
            <div
              class="
                com_order
                two_row
                com_order_box com_state_box
                state_three_row
              "
              :class="
                item.status == 'WAIT_VERIF' || item.status == 'WAIT_ACCEPT'
                  ? 'acceptance'
                  : ''
              "
            >
              <template v-if="!orderItems.refund">
                <!-- <template v-if="item.status != 'CLOSE'"> -->
                <template>
                  <div class="remaining_time" v-if="item.status == 'WAIT_PAY'">
                    {{ item.expirationTimeStr }}
                  </div>
                  <div
                    class="remaining_time"
                    v-if="
                      item.status == 'WAIT_ACCEPT' && item.isAcceptance == false
                    "
                  >
                    等待重新完工拍照
                  </div>
                  <div
                    class="remaining_time"
                    v-if="
                      item.status == 'WAIT_ACCEPT' && item.isAcceptance == null
                    "
                  >
                    {{ item.acceptTimeStr }}
                  </div>
                  <div class="state_text" v-if="item.status == 'WAIT_VERIF'">
                    *等待师傅完成核销
                  </div>

                  <div
                    style="margin-bottom: 8px"
                    class="com_check"
                    v-if="item.status == 'WAIT_PAY'"
                    @click="orderPayment(item)"
                  >
                    立即付款
                  </div>

                  <!-- <div
                    class="com_check"
                    style="
                      color: #c0c4cc;
                      cursor: not-allowed;
                      background-image: none;
                      background-color: #fff;
                      border: 1px solid #ebeef5;
                    "
                    v-if="item.status == 'WAIT_ASSIGN'"
                  >
                    确认到货
                  </div> -->
                  <div
                    class="com_check"
                    v-if="
                      (item.status == 'WAIT_ASSIGN' ||
                        item.status == 'WAIT_APPOINTMENT' ||
                        item.status == 'RECEIVING_ORDER') &&
                      !item.isArrival
                    "
                    @click="arrival(item, index)"
                  >
                    确认到货
                  </div>

                  <div
                    class="com_check com_dib_check"
                    v-if="item.status == 'WAIT_VERIF'"
                  >
                    立即验收
                  </div>
                  <div
                    class="com_check com_dib_check"
                    v-if="
                      item.status == 'WAIT_ACCEPT' && item.isAcceptance == false
                    "
                  >
                    立即验收
                  </div>
                  <div
                    class="com_check"
                    v-if="
                      item.status == 'WAIT_ACCEPT' && item.isAcceptance == null
                    "
                    @click="openAcceptance(item)"
                  >
                    立即验收
                  </div>
                  <div
                    class="com_check com_pin_check"
                    v-if="item.status == 'SUCCESS'"
                    @click="openEvaluate(item, index)"
                  >
                    评价
                  </div>
                  <div
                    class="com_state_box_info"
                    v-if="item.status == 'EVALUATED'"
                  >
                    已评价
                  </div>
                  <template v-if="item.orderType != 'TIMELY'">
                    <div
                      class="com_check"
                      v-if="
                        item.isGoodsAbnormal &&
                        item.status != 'WAIT_VERIF' &&
                        item.status != 'WAIT_ACCEPT' &&
                        !item.solveExceptionWay
                      "
                      @click="processAbnormal(item)"
                    >
                      处理异常
                    </div>
                  </template>

                  <div class="order-bottom">
                    <!-- <div
                      class="com_state_box_info"
                      v-if="item.status == 'WAIT_PAY'"
                      @click="orderCancel(item)"
                    >
                      取消订单
                    </div> -->

                    <div
                      class="com_state_box_info"
                      @click="openOrderInfo(item)"
                    >
                      订单详情
                    </div>

                    <el-divider direction="vertical"></el-divider>
                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link">
                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-if="item.status == 'WAIT_PAY'"
                          :command="{ data: item, type: '取消订单' }"
                          >取消订单</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="
                            item.status == 'WAIT_ACCEPT' &&
                            item.isAcceptance == null &&
                            item.acceptanceDelayDays <= 0
                          "
                          :command="{ data: item, type: '延长验收' }"
                          >延长验收</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="
                            item.status != 'WAIT_PAY' && item.status != 'CLOSE'
                          "
                          :command="{ data: item, type: '添加异常' }"
                          >添加异常</el-dropdown-item
                        >
                        <template>
                          <el-dropdown-item
                            v-if="
                              item.status != 'WAIT_PAY' &&
                              item.status != 'CLOSE'
                            "
                            :command="{
                              data: item,
                              type: '订单加价',
                              index: index,
                            }"
                            >订单加价</el-dropdown-item
                          >
                        </template>
                        <el-dropdown-item
                          v-if="
                            item.status != 'WAIT_PAY' &&
                            item.status != 'CLOSE' &&
                            item.status != 'SUCCESS' &&
                            item.status != 'EVALUATED'
                          "
                          :command="{ data: item, type: '申请退款' }"
                          >申请退款</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="item.orderType == 'TIMELY'"
                          :command="{ data: item, type: '复制订单' }"
                          >复制订单</el-dropdown-item
                        >
                        <!-- <el-dropdown-item v-if="item.status != 'WAIT_PAY'"
                          >投诉</el-dropdown-item
                        > -->
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <!-- <div
                    class="com_state_box_info"
                    :class="item.acceptanceDelayDays > 0 ? 'extend' : ''"
                    @click="extendOrder(item)"
                    v-if="
                      item.status == 'WAIT_ACCEPT' && item.isAcceptance == null
                    "
                  >
                    延长验收
                  </div> -->
                </template>
                <!-- <div class="com_state_box_info" v-if="item.status == 'CLOSE'">
                  /
                </div> -->
              </template>
              <template v-if="orderItems.refund">
                <!-- <div
                  class="com_state_box_info"
                  v-if="item.status == 'WAIT'"
                  @click="openRefund(item, 'modify')"
                >
                  修改退款
                </div> -->
                <div
                  class="com_state_box_info"
                  v-if="item.status == 'WAIT'"
                  @click="arbitrationCancel(item, 'tuik')"
                >
                  取消退款
                </div>
                <div
                  class="com_state_box_info blue"
                  v-if="item.status == 'REFUSE'"
                  @click="openRefund(item, 'renew')"
                >
                  重新退款
                </div>
                <div
                  class="com_state_box_info"
                  v-if="item.status == 'REFUSE'"
                  @click="openArbitration(item, 'zongcai')"
                >
                  退款仲裁
                </div>
                <!-- <div
                  class="com_state_box_info"
                  v-if="item.status == 'REFUSE'"
                  @click="arbitrationCancel(item, 'jixu')"
                >
                  继续服务
                </div> -->
                <!-- <div
                  class="com_state_box_info"
                  v-if="
                    item.status == 'CANCEL' ||
                    item.status == 'PROCESSED' ||
                    item.status == 'SUCCESS' ||
                    item.status == 'ARBITRATION_CANCEL' ||
                    item.status == 'AGREE'
                  "
                >
                  /
                </div> -->
                <div
                  class="com_state_box_info blue"
                  v-if="item.status == 'ARBITRATION'"
                  @click="arbitrationCancel(item, 'zongcai')"
                >
                  取消仲裁
                </div>
                <div
                  class="com_state_box_info"
                  v-if="item.status != 'WAIT'"
                  @click="openOrderInfo(item)"
                >
                  订单详情
                </div>
              </template>
            </div>
            <!-- <span class="refuse-tips" v-if="item.status == 'REFUSE'"
              >（继续服务后师傅才能进行下一步操作）</span
            > -->
          </div>
          <!-- 跟进 -->
          <div class="add-remark" v-if="!orderItems.refund">
            <div>
              跟进记录：<span v-if="item.orderFollow">{{
                item.orderFollow.content
              }}</span
              ><span v-else>暂无</span>
            </div>
            <div class="add-title" @click="addFollowUp(item)">
              <div class="add-icon"></div>
              添加
            </div>
          </div>
        </div>
      </div>

      <el-dialog title="确认商品到货" :visible.sync="inArrival" class="arrival">
        <div>
          <div class="arrival-tishi">为了确保师傅顺利取货，请补充物流信息</div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>物流单号</div>
            <div class="type_content">
              <el-input
                v-model="logisticsData.logisticsNo"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>物流电话</div>
            <div class="type_content">
              <el-input
                v-model="logisticsData.logisticsPhone"
                placeholder="请输入"
                maxlength="12"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">物流公司</div>
            <div class="type_content">
              <!-- <el-input
                v-model="logisticsData.logisticsCompany"
                placeholder="请输入"
              ></el-input> -->
              <el-select
                v-model="logisticsData.logisticsCompany"
                filterable
                remote
                reserve-keyword
                placeholder="请输入物流公司名称"
                :remote-method="getLogisticsCompany"
                :loading="loading"
                @change="getLogisticsCompany"
              >
                <el-option
                  v-for="item in logisticsCompany"
                  :key="item.value"
                  :label="item.companyName"
                  :value="item.companyCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">提货码</div>
            <div class="type_content">
              <el-input
                v-model="logisticsData.pickupCode"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">提货地址</div>
            <div class="type_content">
              <el-input
                v-model="logisticsData.pickupAddress"
                placeholder="请输入"
                @input="getPickUpLnglat"
              ></el-input>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="inArrival = false">取 消</el-button>
          <el-button type="primary" @click="isarrival()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title :visible.sync="notArrival">
        <div class="notarrival">
          <svg class="icon iconz_toast_warn" aria-hidden="true">
            <use xlink:href="#iconz_toast_warn" />
          </svg>
          确认修改商品状态为已到货吗？
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="notArrival = false">取 消</el-button>
          <el-button type="primary" @click="isarrival()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 评价 -->
      <el-dialog
        title="评价师傅"
        :visible.sync="evaluate"
        width="30%"
        class="complaint evaluate"
      >
        <div>
          <div class="evaluate-tab">
            <div class="tab_name">下单时间：</div>
            {{ temOrderInfo.createTime.tryParseDate().format("yyyy-MM-dd") }}
          </div>
          <div class="evaluate-tab">
            <div class="tab_name">服务类型：</div>
            {{ temOrderInfo.serviceTypeName }}
          </div>
          <div class="evaluate-tab evaluate-img">
            <div class="tab_name">安装师傅：</div>
            <img
              class="avatar-evaluate"
              :src="
                !temOrderInfo.workerAvatar == true
                  ? workerAvatar
                  : temOrderInfo.workerAvatar
              "
              alt
            />
            {{ temOrderInfo.workerName }}
          </div>
          <div class="evaluate-tab imgs-eva">
            <div class="tab_name">商品图片：</div>
            <img
              class="item-imgs"
              v-for="(item, index) in temOrderInfo.orderItems"
              :src="item.imgUrl"
              alt
            />
          </div>
          <div class="evaluate-tab imgs-score rate-size">
            <div class="tab_name">
              <span style="color: #f75658">*</span>师傅评分：
            </div>
            <el-rate
              v-model="rateValue"
              void-icon-class="iconfont iconguanwang_icon_pingjia"
              :icon-classes="iconClasses"
              :colors="['#FFAD16', '#FFAD16', '#FFAD16']"
              :texts="texts"
              show-text
            ></el-rate>
          </div>
          <div class="evaluate-tab eva-impression">
            <div class="tab_name">印象标签：</div>
            <div class="impression">
              <div
                class="tabs"
                v-for="(item, index) in impressionList"
                @click="impressionCheck(item)"
                :class="{ selected: item.isSelected }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="evaluate-tab eva-content">
            <div class="tab_name">评价内容：</div>
            <el-input
              v-model="impressionContent"
              placeholder="师傅是否满足您的要求？快填写评价吧~"
              type="textarea"
              class="textarea-text"
              maxlength="500"
              show-word-limit
            ></el-input>
          </div>
          <div class="complaint-img eva-upload-imgs">
            <div class="complaint-title">相关图片</div>
            <a-upload
              :action="baseApl + '/common/common/upload_file'"
              listType="picture-card"
              :fileList="evaluateList"
              @change="evaluateChange"
              :data="webToken"
              :headers="webToken"
            >
              <div v-if="evaluateList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="evaluate = false">取 消</el-button>
          <el-button type="primary" @click="evaluateCheck()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 申请退款仲裁 -->
      <el-dialog
        title="申请退款仲裁"
        :visible.sync="arbitration"
        width="30%"
        class="arbitration complaint"
      >
        <div>
          <div class="arbitration-title">
            订单总金额
            <span>¥{{ arbitrationInfo.orderAmount }}</span>
          </div>
          <div class="fu-title">· 师傅补贴费</div>
          <el-input
            class="default-input"
            v-model="masterPrice"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            @input="watchNumber"
            :placeholder="'最多￥' + arbitrationInfo.workerCashIntransit + '元'"
          ></el-input>
          <div class="arbitration-tips">师傅补贴费为支付给师傅的费用</div>
          <div class="fu-title">
            · 退款金额
            <!-- <span style="color: #f75658">
              ¥{{
                (arbitrationInfo.orderAmount * 1000 - masterPrice * 1000) / 1000
              }}
            </span> -->
            <span style="color: #f75658">
              ¥{{ (arbitrationInfo.orderAmount - masterPrice).toFixed(2) }}
            </span>
          </div>
          <div class="arbitration-tips">
            师傅补贴费为支付给师傅的费用，退款金额=订单总金额-师傅补贴费
          </div>
          <div class="arbitration-content">
            <span style="color: #f75658">*</span>仲裁内容
          </div>
          <el-input
            class="default-input"
            v-model="arbitrationListContent"
            placeholder="请输入仲裁内容"
            type="textarea"
          ></el-input>

          <div class="complaint-img eva-upload-imgs">
            <div class="complaint-title">相关图片</div>
            <a-upload
              :action="baseApl + '/common/common/upload_file'"
              listType="picture-card"
              :fileList="arbitrationList"
              @change="arbitrationChange"
              :data="webToken"
              :headers="webToken"
            >
              <div v-if="arbitrationList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="arbitration = false">取 消</el-button>
          <el-button type="primary" @click="submitarbitration()"
            >提 交</el-button
          >
        </span>
      </el-dialog>

      <!-- 获取货物异常 -->
      <el-dialog
        title="货物异常详情"
        :visible.sync="abnormal"
        width="30%"
        class="abnormal complaint"
      >
        <div>
          <div class="two_label">
            <div class="type_name">详细内容</div>
            <div class="type_content">{{ abnormalData.content }}</div>
          </div>

          <div class="two_label">
            <div class="type_name">相关图片</div>
            <div class="type_content">
              <!-- <img v-for="(item, index) in abnormalData.imgs" :key="index" :src="item.url" alt=""> -->
              <el-image
                v-for="(item, index) in abnormalData.imgs"
                :key="index"
                :src="item.url"
                :preview-src-list="abnormalImgList"
              ></el-image>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="abnormal = false">取 消</el-button>
          <el-button type="primary" @click="abnormal = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-pagination
      v-show="orderItems.total > 6"
      class="fenye"
      background
      layout="prev, pager, next"
      :total="orderItems.total"
      :page-size="6"
      @current-change="pageSize"
    ></el-pagination>
    <increase-price
      :orderData="orderData"
      :markup="markup"
      v-on:showMarkup="showMarkup"
      v-on:increasePrice="increasePrice"
    ></increase-price>
    <com-complaint
      :orderNo="complaintOrderNo"
      :status="complaintStatus"
      :complaint="complaint"
      v-on:showComplaint="showComplaint"
    ></com-complaint>
    <orderInfo-modal ref="orderInfoModal" @ok="$emit('ok')"></orderInfo-modal>
    <videoCall-modal ref="videoCallModal"></videoCall-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <followup-modal ref="followupModal" @ok="$emit('ok')"></followup-modal>
    <abnormalFollow-modal
      ref="abnormalFollowModal"
      @ok="$emit('ok')"
    ></abnormalFollow-modal>
    <batchPay-modal
      ref="batchPayModal"
      :markup="batchPayShow"
      :orderData="orderData"
      @ok="onBatchPay()"
    ></batchPay-modal>
  </div>
</template>

<script>
import increasePrice from "./increase_price";
import comComplaint from "./com_complaint";
import orderInfoModal from "./modules/orderInfoModal";
import videoCallModal from "./modules/videoCallModal";
import followupModal from "./modules/followupModal";
import abnormalFollowModal from "./modules/abnormalFollowModal";
import { ORDER_STATUS } from "@/utils/constant";
import batchPayModal from "./modules/batchPayModal";
import { getAction } from "@/api/manage";
import { arithmeticMultiply, arithmeticDivide } from "@/utils/util";
import { copyMixins } from "@/mixins/copyMixins";
import $ from "jquery";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  mixins: [copyMixins],
  components: {
    increasePrice,
    comComplaint,
    orderInfoModal,
    videoCallModal,
    followupModal,
    abnormalFollowModal,
    batchPayModal,
  },
  props: {
    orderItems: Object,
    home: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      batchPayBtn: false, // 批量支付显示隐藏
      batchPayShow: false,
      inArrival: false,
      notArrival: false,
      markup: false,
      dialogVisible: false,
      icon: false,
      complaint: false,
      complaintOrderNo: "", // 投诉订单号
      complaintStatus: "", // 投诉状态
      evaluate: false,
      arbitration: false,
      payMode: [{ selected: true }, { selected: false }, { selected: false }],
      payWayEnum: "WALLET",
      balance: 0,
      tabNum: 0, //判断下标
      logisticsData: {
        logisticsNo: "",
        logisticsPhone: "",
        logisticsCompany: "",
        pickupCode: "",
        pickupAddress: "",
      },
      orderData: {},
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      fileList: [],
      evaluateList: [],
      impressionList: [],
      followUpList: [],
      rateValue: 0,
      texts: ["非常差", "差", "一般", "好", "非常好"],
      iconClasses: [
        "iconfont iconguanwang_icon_pingjia",
        "iconfont iconguanwang_icon_pingjia",
        "iconfont iconguanwang_icon_pingjia",
      ],
      temOrderInfo: {
        createTime: "2019-9-1",
      },
      workerAvatar: require("../../assets/img/pic_head_nor.png"),
      impressionContent: "",
      arbitrationListContent: "",
      arbitrationList: [],
      arbitrationInfo: {},
      masterPrice: "",
      abnormal: false, //异常
      abnormalData: {},
      abnormalImgList: [],
      showEdit: false,
      remark: "",
      remarkInfo: {},
      loading: false,
      baseApl: process.env.VUE_APP_BASE_API,
      isIndeterminate: false,
      checkAll: false,
      multipleSelection: [],
      previewVisible: false,
      previewImage: "",
      logisticsCompany: [],
    };
  },
  mounted() {
    this.getLogisticsCompany();
  },
  watch: {
    multipleSelection() {
      if (!this.multipleSelection.length) {
        // this.handleCheckAllChange = false;
        this.isIndeterminate = false;
      }
      if (this.multipleSelection.length == this.orderItems.total) {
        this.isIndeterminate = false;
        this.checkAll = true;
      }
    },
  },
  // 接收注入的数据
  inject: ["reload", "videoCall"],
  methods: {
    // 保留两位小数
    watchNumber(e) {
      if (e > Number(this.arbitrationInfo.workerCashIntransit))
        return (this.masterPrice = this.arbitrationInfo.workerCashIntransit);
      if (e.split(".").length == 3) {
        this.masterPrice = e.substr(0, e.length - 1);
      } else {
        if (e.split(".")[1]) {
          // this.markupPrice = Math.floor(e * 10000) / 10000;
          this.masterPrice = arithmeticDivide(
            Math.floor(arithmeticMultiply(e, 100)),
            100
          );
        }
      }
    },
    onBatchPay() {
      this.checkAll = false;
      this.multipleSelection = [];
      this.$emit("ok");
    },
    // 获取全部待支付订单
    getwaitPayOrder(e) {
      getAction("/order/api/order/get_waitpay_order").then(({ data }) => {
        console.log(data);
        if (data.code == 0) {
          if (e) this.multipleSelection = data.data.map((i) => i.id);
          else this.multipleSelection = [];
          this.orderItems.rows.map((i) => {
            if (e) i.checked = true;
            else i.checked = false;
          });
        }
      });
    },
    // 批量加价
    batchPay() {
      if (this.multipleSelection.length) {
        this.batchPayShow = true;
        setTimeout(() => {
          this.$refs.batchPayModal.init(this.multipleSelection);
        });
      } else this.$message.warning("请至少选择一个订单");
    },
    // 获取物流公司
    getLogisticsCompany(e) {
      console.log(e);
      let params = {
        name: e,
        pageNo: 1,
        pageSize: 20,
      };
      this.$fetch("/common/api/wuliu/wuliu_company_search", params).then(
        (res) => {
          if (res.code == 0) {
            this.logisticsCompany = res.data.records;
          }
        }
      );
    },
    setStatus(status) {
      for (let i in ORDER_STATUS) {
        if (i == status) return "（送货-" + ORDER_STATUS[i].name + "）";
      }
    },
    handleCommand(item = {}) {
      this.$message.closeAll();
      console.log(item);
      if (item.type == "取消订单") return this.orderCancel(item.data);
      else if (item.type == "订单加价")
        return this.markupCheck(item.data, item.index);
      else if (item.type == "申请退款")
        return this.openRefund(item.data, item.index);
      else if (item.type == "延长验收") return this.extendOrder(item.data);
      else if (item.type == "添加异常")
        return this.addAbnormalFollow(item.data);
      else if (item.type == "复制订单") return this.copyOrder(item.data);
    },

    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 选择订单
    checkOrder(item) {
      console.log(item);
      if (item.checked) this.multipleSelection.push(item.id);
      else
        this.multipleSelection.splice(
          this.multipleSelection.findIndex((i) => i === item.id),
          1
        );
      // item.checked=!item.checked
      this.isIndeterminate = true;
    },
    // 全选
    handleCheckAllChange(e) {
      console.log(e);
      this.$forceUpdate();
      this.isIndeterminate = false;
      this.getwaitPayOrder(e);
    },
    isVideoCall(item) {
      console.log(item);
      if (this.orderItems.refund) {
        let params = Object.assign(item, { workerId: item.verifyWorkerId });
        sessionStorage.setItem("orderId", item.orderId);
        this.$refs.videoCallModal.init(params);
      } else {
        sessionStorage.setItem("orderId", item.id);
        this.$refs.videoCallModal.init(item);
      }
    },
    showMarkup(val) {
      this.markup = val;
    },
    showComplaint(val) {
      this.complaint = val;
    },
    pageSize(val) {
      this.$emit("pagesize", val);
    },
    // 添加异常
    addAbnormalFollow(item) {
      this.$refs.abnormalFollowModal.add(item);
    },
    // 打开备注编辑
    addFollowUp(item) {
      this.$refs.followupModal.add(item);
    },
    // 打开投诉
    complaintCheck(item, index) {
      this.complaintOrderNo = item.orderNo;
      this.complaintStatus = item.status;
      this.complaint = true;
    },
    // 跳转异常处理
    processAbnormal(item) {
      this.$router.push({
        path: "/user/order/abnormal",
        query: { orderid: item.id },
      });
    },
    // 查看异常详情
    abnormalInfo(item) {
      let _this = this;
      this.abnormal = true;
      this.$fetch(`/order/api/goods_pick_up?oid=${item.id}`).then((res) => {
        if (res.code == 0) {
          _this.abnormalData = res.data;
          res.data.imgs.map((i) => {
            this.abnormalImgList.push(i.url);
          });
        } else {
          this.$message(res.message);
        }
      });
    },
    // 查询提货位置
    getPickUpLnglat() {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        address: this.logisticsData.pickupAddress,
      };

      $.ajax({
        type: "get",
        dataType: "jsonp",
        cache: false,
        data: params,
        url: "https://restapi.amap.com/v3/geocode/geo",

        success: function (json) {
          console.log(json);
          if (json.info == "OK") {
            _this.logisticsData.pickUpLng =
              json.geocodes[0].location.split(",")[0];
            _this.logisticsData.pickUpLat =
              json.geocodes[0].location.split(",")[1];
          }
        },
      });
    },
    // 确认到货
    arrival(item, index) {
      this.tabNum = index;
      if (item.isNeedTakeDelivery) {
        this.inArrival = true;
        this.logisticsData = {
          logisticsNo: item.logisticsNo,
          logisticsPhone: item.logisticsPhone,
          logisticsCompany: item.logisticsCompany,
          pickupAddress: item.pickupAddress,
          pickupCode: item.pickupCode,
        };
      } else {
        this.notArrival = true;
      }
    },
    isarrival() {
      var _this = this;
      // var myreg = /^1[123456789]\d{9}$/;
      var item = _this.orderItems.rows[_this.tabNum];
      var data = _this.logisticsData;
      if (this.inArrival) {
        if (data.logisticsNo == "") {
          this.$message({
            showClose: true,
            message: "请输入物流单号",
            type: "error",
          });
          return;
        }
        if (parseFloat(data.logisticsPhone).toString() == "NaN") {
          this.$message({
            showClose: true,
            message: "请输入合法的手机号",
            type: "error",
          });
          return;
        }
      }

      this.$post(`/order/api/order/${item.id}/arrival`, {
        logisticsNo: data.logisticsNo,
        logisticsPhone: data.logisticsPhone,
        logisticsCompany: data.logisticsCompany,
        pickupCode: data.pickupCode,
        pickupAddress: data.pickupAddress,
        pickUpLat: data.pickUpLat,
        pickUpLng: data.pickUpLng,
      }).then((res) => {
        if (res.code == 0) {
          _this.notArrival = false;
          _this.inArrival = false;
          item.isArrival = true;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 加价
    markupCheck(item, index) {
      var _this = this;
      if (item.orderType != "TIMELY") {
        if (item.status == "SUCCESS" || item.status == "EVALUATED") {
          this.$confirm(
            "当前订单已交易完成，已无法申请退款。订单加价支付后将会直接到师傅账上。",
            "加价提醒",
            { confirmButtonText: "我知道了", cancelButtonText: "不加价了" }
          )
            .then(() => {
              _this.orderData = item;
              this.markup = true;
              this.tabNum = index;
            })
            .catch(() => {});
        } else {
          _this.orderData = item;
          this.markup = true;
          this.tabNum = index;
        }
      } else {
        sessionStorage.setItem("orderId", item.id);
        this.$refs.videoCallModal.init(item, "markup");
      }
    },
    // 加价了多少钱
    increasePrice(val) {
      var item = {};
      item = this.orderItems.rows[this.tabNum];
      item.totalAmount =
        (Number(val) * 1000 + Number(item.totalAmount) * 1000) / 1000;
    },
    // 立即付款
    orderPayment(item) {
      this.$router.push({
        path: "/placeorder/Orderpayment",
        query: { orderid: item.id },
      });
    },
    // 取消订单
    orderCancel(item) {
      console.log(item);
      this.$confirm("您确定要取消此订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post(`/order/api/order/${item.id}/cancel`).then((res) => {
            if (res.code == 0) {
              item.status = "CLOSE";
              item.statusName = "订单关闭";
              // _this.orderItems.rows.remove(item);
              this.$message({
                type: "success",
                message: "取消成功!",
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
    // 延长验收
    extendOrder(item) {
      console.log(item);
      if (!item.acceptanceDelayDays) {
        this.$confirm("确定延长验收吗？每笔订单只能延长一次", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$fetch(
              `/order/api/order/acceptance_order_delay?orderId=${item.id}`
            ).then((res) => {
              if (res.code == 0) {
                item.acceptanceDelayDays = 1;
                item.acceptTimeStr = res.data.acceptTimeStr;
                this.$message({
                  type: "success",
                  message: "延长成功!",
                });
              } else {
                this.$message(res.message);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 进入仲裁详情
    arbitrationDetail(item) {
      this.$router.push({
        path: "/user/right/detail",
        query: { refundId: item.id },
      });
    },
    // 取消申请仲裁
    arbitrationCancel(item, tab) {
      let text = "";
      if (tab == "tuik") {
        text = "您确定要取消此退款?";
      }
      if (tab == "zongcai") {
        text = "您确定要取消此仲裁?";
      }
      if (tab == "jixu") {
        text =
          "同意师傅继续服务后，他才能继续下一步操作，后续你仍然可以随时发起退款申请";
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post(`/order/api/refund/${item.id}/cancel`).then((res) => {
            if (res.code == 0) {
              if (tab != "jixu") {
                if (item.status == "WAIT") {
                  item.status = "CANCEL";
                  // _this.orderItems.rows.remove(item);
                } else {
                  item.status = "REFUSE";
                }
              } else {
                this.$emit("pagesize", 1);
              }

              this.$message({
                type: "success",
                message: "操作成功!",
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
    // 跳转订单详情
    openOrderInfo(item) {
      this.$refs.orderInfoModal.open(item, this.orderItems.refund);
      if (this.orderItems.refund) {
        this.$refs.orderInfoModal.isRefund();
      }
    },
    // 跳转验收
    openAcceptance(item) {
      this.$router.push({
        path: "/user/order/acceptance",
        query: { orderid: item.id },
      });
    },
    // 申请退款
    openRefund(item, flag) {
      // console.log(item)
      // console.log(flag)
      if (!flag) {
        if (item.status == "RECEIVING_ORDER" && item.childOrder&&item.childOrder.workerId) {
          return this.$router.push({
            path: "/user/order/refund/modify",
            query: { orderid: item.id },
          });
        }
        if (
          item.status == "RECEIVING_ORDER" ||
          item.status == "WAIT_PAY" ||
          item.status == "WAIT_ASSIGN"
        ) {
          this.$confirm("您确定要退款吗", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$fetch(
                `/order/api/order/${item.id}/wait_assign_order_refund`
              ).then((res) => {
                if (res.code == 0) {
                  item.status = "CLOSE";
                  item.statusName = "订单关闭";
                  this.$message({
                    type: "success",
                    message: "退款成功!",
                  });
                } else {
                  this.$message(res.message);
                }
              });
            })
            .catch(() => {});
        } else {
          this.$router.push({
            path: "/user/order/refund/modify",
            query: { orderid: item.id },
          });
        }
      } else {
        this.$router.push({
          path: "/user/order/refund/modify",
          query: { orderid: item.orderId, type: flag },
        });
      }
    },
    // 接单中退款
    // 投诉拍照
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    // 评论拍照
    evaluateChange({ fileList }) {
      this.evaluateList = fileList;
    },
    // 退款仲裁拍照拍照
    arbitrationChange({ fileList }) {
      this.arbitrationList = fileList;
    },
    // // 订单跟进拍照
    // followUpChange({ fileList }) {
    //   this.followUpList = fileList;
    // },
    impressionCheck(item) {
      item.isSelected = !item.isSelected;
    },
    // 申请退款仲裁
    openArbitration(item) {
      console.log(item);
      this.arbitration = true;
      this.arbitrationInfo = item;
    },
    submitarbitration() {
      this.$message.closeAll();
      var _this = this;
      let imgs = [];
      for (let i of _this.arbitrationList) {
        imgs.push(i.response.data.url);
      }
      this.$post(`/order/api/refund/${_this.arbitrationInfo.id}/arbitration`, {
        allowance: _this.masterPrice,
        content: _this.arbitrationListContent,
        imgs: imgs,
      }).then((res) => {
        if (res.code == 0) {
          this.arbitrationInfo.status = "ARBITRATION";
          this.arbitration = false;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 评价师傅
    openEvaluate(item, index) {
      var _this = this;
      this.$fetch(`/common/api/tag`).then((res) => {
        if (res.code == 0) {
          for (let i of res.data) {
            i.isSelected = false;
            i.name = i.content;
          }
          _this.evaluate = true;
          _this.tabNum = index;
          _this.temOrderInfo = item;
          _this.impressionList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    evaluateCheck() {
      var _this = this;
      var label = [];
      var imgs = [];
      for (let i of _this.impressionList) {
        if (i.isSelected) {
          label.push(i.name);
        }
      }
      for (let i of _this.evaluateList) {
        imgs.push(i.response.data.url);
      }
      this.$post(`/order/api/order/${this.temOrderInfo.id}/evaluation`, {
        star: _this.rateValue,
        content: _this.impressionContent,
        isAnonymous: false,
        label: label,
        imgs: imgs,
      }).then((res) => {
        if (res.code == 0) {
          _this.evaluate = false;
          _this.orderItems.rows[_this.tabNum].status = "EVALUATED";
          this.$message({
            message: "评论成功",
            type: "success",
          });
        } else {
          this.$message(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#orderlist .remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }
  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }
  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }
  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;
    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }
    .el-dialog__headerbtn {
      top: 16px;
    }
  }
  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;
    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}
#orderlist /deep/.genjinupload {
  margin-top: 20px;
  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }
  .ant-upload-list {
    height: 80px !important;
  }
  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
  }
}
.add-remark {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  & > div {
    display: flex;
    align-items: center;
  }
  & > div:first-child {
    color: #2f3133;
    span {
      margin-left: 16px;
      color: #909399;
      width: 805px;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .add-title {
    width: 44px;
    margin: 0;
  }
}
.batch_pay {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  margin-top: 10px;
  height: 24px;
  width: 158px;
  font-size: 12px;
  margin-left: 20px;
  .checkbox {
    margin-top: 0;
  }
  & > span {
    color: #3455d3;
    margin-left: 4px;
  }
  .batch_pay_btn {
    margin-left: 12px;
    height: 24px !important;
    width: 80px !important;
    font-size: 12px;
    color: #5e6066 !important;
    border-color: #dcdfe6 !important;
  }
}
/deep/.checkbox {
  .is-focus {
    .el-checkbox__inner {
      border-color: #3455d3 !important;
    }
  }
  .el-checkbox__label {
    padding-left: 4px;
    color: #5e6066;
  }
  .el-checkbox__inner:hover {
    border-color: #3455d3;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3455d3;
    border-color: #3455d3;
  }
}
/deep/.com_order_num {
  .el-checkbox__label {
    display: none;
  }
  .el-checkbox__input,
  .el-checkbox__inner {
    margin: 0 !important;
  }
  .ochenck {
    margin-right: 12px;
    margin-top: 0;
  }
}
</style>
<style lang="scss">
.el-message-box__status + .el-message-box__message {
  padding-bottom: 6px;
}
.fenye {
  text-align: right;
  margin: 30px 0 0px 0;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  border: 1px solid #3455d3;
  color: #5e6066 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #3455d3 !important;
  color: #fff !important;
  border: 1px solid #3455d3 !important;
  border-radius: 2px;
}
.el-pagination.is-background .el-pager li {
  border: 1px solid #ced4db;
  font-weight: initial !important;
}
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: #fff !important;
  border: 1px solid #ced4db !important;
}
#orderlist {
  .arbitration {
    color: #2f3133;
    .default-input {
      input {
        width: 100%;
      }
      textarea {
        resize: none;
        border-radius: 2px;
        height: 130px;
      }
      textarea::placeholder {
        font-size: 14px;
      }
      input::placeholder {
        font-size: 14px;
      }
    }
    .arbitration-title {
      height: 14px;
      font-size: 14px;
      line-height: 1;
      span {
        margin-left: 16px;
      }
    }
    .arbitration-content {
      margin-top: 32px;
      margin-bottom: 14px;
      height: 14px;
      font-size: 14px;
      line-height: 1;
    }
    .arbitration-tips {
      color: #909399;
      font-size: 12px;
      height: 12px;
      line-height: 1;
      margin-top: 8px;
    }
    .fu-title {
      height: 12px;
      line-height: 1;
      font-size: 12px;
      margin: 24px 0 14px 0;
    }
  }
  .pass {
    .el-dialog__header {
      padding: 20px 45px 10px !important;
    }
    .el-dialog__body {
      padding: 5px 45px !important;
      position: relative;
      .icon {
        position: absolute;
        right: 45px;
        top: 15px;
        width: 19px;
        height: 19px;
        color: #c9cdd5;
        cursor: pointer;
      }
    }
    .el-dialog__footer {
      padding: 10px 45px 20px;
      margin-top: 10px;
    }
  }

  .notarrival {
    display: flex;
    align-items: center;
  }
  .arrival {
    .two_label {
      .type_name {
        width: 69px;
      }
    }
    .type_content {
      &/deep/.el-input {
        input {
          border-bottom: 1px solid #dcdfe6 !important;
        }
      }
    }
  }
  .arrival-tishi {
    font-size: 12px;
    height: 12px;
    line-height: 1;
    color: #909399;
    margin-bottom: 24px;
  }
  .el-dialog {
    width: 459px !important;
  }
  .evaluate {
    .el-dialog__header {
      padding: 20px 12px 10px !important;
    }
    .el-rate {
      height: 32px !important;
    }
    .rate-size {
      .iconguanwang_icon_pingjia {
        font-size: 32px !important;
      }
    }

    .el-dialog__body {
      padding: 5px 12px !important;
      position: relative;
      .icon {
        position: absolute;
        right: 45px;
        top: 15px;
        width: 19px;
        height: 19px;
        color: #c9cdd5;
        cursor: pointer;
      }
    }
    .el-dialog__footer {
      padding: 10px 12px 20px;
      margin-top: 10px;
    }
    .evaluate-tab {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      color: #2f3133;
      margin-bottom: 16px;
      .tab_name {
        width: 77px;
        margin-right: 10px;
        color: #5e6066;
      }
      .avatar-evaluate {
        width: 34px;
        height: 34px;
        margin-right: 12px;
      }
    }
    .evaluate-img {
      height: 36px;
    }
    .imgs-eva {
      height: 60px;
      align-items: flex-start;
      .item-imgs {
        width: 60px;
        height: 60px;
        margin-right: 7px;
      }
      .item-imgs:last-child {
        margin-right: 0px;
      }
    }
    .imgs-score {
      height: 32px;
      align-items: center;
      color: #5e6066;
      .item-imgs {
        width: 32px;
        height: 32px;
        margin-right: 7px;
      }
      .item-imgs:nth-child(6) {
        margin-right: 15px;
      }
    }
    .eva-impression {
      min-height: 70px;
      .impression {
        display: flex;
        flex-wrap: wrap;
        width: 480px;
        .tabs {
          padding: 9px 11px;
          border: 1px solid #b4b7bc;
          border-radius: 16px;
          font-size: 12px;
          color: #5e6066;
          cursor: pointer;
          margin: 0 8px 6px 0;
        }
        .selected {
          border-color: #3455d3;
          color: #3455d3;
        }
        .tabs:last-child {
          margin: 0 0 6px 0;
        }
      }
    }
    .eva-content {
      height: 187px;
      align-items: flex-start;
      .textarea-text {
        width: 460px;
        height: 187px;
        textarea {
          resize: none;
          height: 100%;
          border-radius: 2px;
        }
        textarea:hover,
        textarea:focus {
          border-color: #3455d3;
        }
      }
    }
    .eva-upload-imgs {
      display: flex;
      .complaint-title {
        margin-right: 26px !important;
      }
      .ant-upload-list-item {
        width: 52px !important;
        height: 52px !important;
        margin: 0 7px 5px 0 !important;
      }
      .ant-upload.ant-upload-select-picture-card {
        width: 52px !important;
        height: 52px !important;
        // margin-left: 0 !important;
      }
    }
    .el-dialog {
      width: 572px !important;
    }
  }
  .el-input__inner {
    height: 40px !important;
  }
  .type_content .el-select input,
  .type_content .el-input input {
    width: 345px !important;
  }
  .el-dialog__header {
    padding: 20px 12px 10px !important;
  }
  .el-dialog__body {
    padding: 5px 12px !important;
    position: relative;
    .iconz_toast_warn {
      color: #3455d3;
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .el-dialog__footer {
    padding: 10px 12px 20px;
    margin-top: 10px;
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-button {
    border-radius: 2px;
  }
  .el-button--primary {
    background: #3455d3;
    color: #fff;
    border-color: #3455d3;
    width: 60px;
    height: 28px;
    padding: 0 !important;
  }
  .el-button--primary:hover {
    background: #2c4abb;
    border-color: #2c4abb;
  }
  .el-button--default:hover {
    color: #3455d3 !important;
    border-color: #3455d3 !important;
    background: #fff !important;
  }
  .el-button--default {
    color: #bec0c6;
    border-color: #bec0c6;
    width: 60px;
    height: 28px;
    padding: 0 !important;
  }
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #3455d3;
  }
  .default-input {
    input {
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      margin-top: 6px;
      padding: 3px 15px;
    }
    input:hover,
    input:focus {
      border-color: #3455d3 !important;
    }
  }
  .complaint {
    .two_label {
      display: block !important;
    }
    .type_name {
      margin-bottom: 12px;
    }
    .type_content {
      margin-left: 0 !important;
      width: 100% !important;
      textarea {
        width: 100% !important;
        height: 130px !important;
      }
    }
    .complaint-img {
      & > span {
        display: flex;
        flex-wrap: wrap;
      }
      .complaint-title {
        font-size: 14px;
        height: 14px;
        line-height: 1;
        color: #2f3133;
        margin: 24px 0 14px 0;
        white-space: nowrap;
      }
      .ant-upload.ant-upload-select-picture-card {
        width: 50px;
        height: 50px;
        border-radius: 2px;
        margin-left: 4px;
        margin-right: 0;
      }
      .ant-upload.ant-upload-select-picture-card > .ant-upload {
        padding: 0;
      }
      .ant-upload.ant-upload-select-picture-card:hover,
      .ant-upload.ant-upload-select-picture-card:hover {
        border-color: #3455d3;
      }
      .ant-upload-text {
        font-size: 12px;
      }
      .ant-upload-list {
        width: auto !important;
        height: 50px;
      }
      .ant-upload-list-picture-card .ant-upload-list-item {
        height: 50px;
        width: 50px;
        margin: 0 5px 5px 0;
        padding: 0;
      }
      .ant-upload-list-picture-card .ant-upload-list-item:last-child {
        margin-right: 0 !important;
      }
      .ant-upload-list-item-info > span {
        height: 100%;
      }
      // .ant-upload-list-item-actions {
      //   & > a {
      //     display: none;
      //   }
      // }
    }
  }
}
.contacts_info {
  display: flex;
  flex-direction: column;
  .td_text {
    font-size: 13px;
    line-height: 13px;
    margin-top: 4px;
    &:first-child {
      margin-top: 0;
    }
  }
  .video_call {
    height: 26px;
    width: 66px !important;
    color: #5e6066 !important;
    font-size: 12px;
    margin-top: 8px;
    border-color: #dcdfe6 !important;
  }
  .kehu_address {
    width: 132px;
    color: #909399;
    font-size: 12px;
    line-height: 14px;
    margin-top: 9px;
    padding: 0 7px;
    span {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
</style>
<style lang="scss">
#orderlist {
  .commodity {
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    .refundrow {
      .com_info {
        width: 238px;
      }
      .com_type {
        width: 83px;
      }
      .com_contacts {
        width: 123px;
      }
      .com_money {
        width: 94px;
      }
      .com_operation {
        width: 91px;
      }
      .com_state {
        width: 114px;
        &::before {
          content: "";
          width: 1px;
          height: 50px;
          background: #e8eef5;
          position: absolute;
          left: 0;
        }
      }
      .com_order {
        width: 120px;
      }
    }
    .com_info {
      // width: 261px;
      width: 238px;
    }
    .com_type {
      // width: 114px;
      width: 88px;
    }
    .com_contacts {
      // width: 104px;
      width: 146px;
    }
    .com_money {
      // width: 94px;
      width: 122px;
    }
    .com_operation {
      // width: 84px;
      width: 96px;
    }
    .com_state {
      // width: 100px;
      width: 108px;
    }
    .com_order {
      // width: 120px;
      width: 162px;
      .order-bottom {
        display: flex;
        padding: 0 24px;
        // width: 106px;
        font-size: 12px;
        align-items: center;
        height: 12px;
        // margin-top: 10px;
        .el-icon--right {
          margin-left: 2px;
        }
        .el-dropdown-link {
          font-size: 12px;
          color: #5e6066;
          cursor: pointer;
          &:hover {
            color: #3455d3;
            .el-icon--right {
              color: #3455d3;
            }
          }
        }
      }
    }
    .commodity_label {
      background: #f9fafa;
      padding-left: 20px;
      height: 36px;
      display: flex;
      justify-content: flex-start;
      border-radius: 2px;
      font-size: 12px;
      .com_tab {
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }
    .commodity_info {
      .null {
        padding: 30px 261px;
        background: #fff;
        text-align: center;
        img {
          width: 375px;
          height: 94px;
        }
        div {
          color: #b4b7bc;
          font-size: 14px;
          margin-top: 8px;
          text-align: center;
        }
      }
      .com_item {
        .com_order_num {
          background: #f9fafa;
          height: 34px;
          display: flex;
          align-items: center;
          color: #909399;
          font-size: 12px;
          padding: 0 0 0 20px;
          margin-top: 10px;
          border-top-left-radius: 2px;
          border-top-right-radius: 2px;
          border-bottom: 1px solid #dfe4eb;
          span {
            margin: 0 10px 0 10px;
          }
          .write_off {
            width: 48px;
            height: 20px;
            border-radius: 2px;
            border: 1px solid rgba(205, 208, 214, 1);
            text-align: center;
            line-height: 18px;
          }
          // .work-info {
          //   flex: 1 1;
          //   text-align: right;
          //   padding-right: 20px;
          // }
          .label_tuikuan {
            text-align: right;
            color: #f75658;
            flex: 1;
            padding-right: 20px;
            cursor: pointer;
            i {
              margin-right: 4px;
            }
          }
          .yichang {
            color: #909399;
            display: inline-flex;
            margin-left: 6px;
            div {
              color: #2f3133;
              margin-left: 16px;
              span {
                color: #f75658;
                margin: 0;
                margin-left: 8px;
                margin-right: 0;
              }
            }
          }
        }

        .com_data {
          display: flex;
          justify-content: flex-start;
          padding: 0 0 0 20px;
          background: #fff;
          position: relative;
          & > div {
            height: 106px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2f3133;
            font-size: 12px;
            position: relative;
            .imgs {
              margin-right: 8px;
            }
            .img_content {
              width: 100%;
              display: flex;
              align-items: center;
              // justify-content: space-between;
              position: relative;
              .count {
                position: absolute;
                width: 100%;
                height: 24px;
                background: rgba(0, 0, 0, 0.5);
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                bottom: 0;
                left: 0;
              }
              img {
                width: 74px;
                height: 74px;
                // margin-right: 8px;
                border-radius: 2px;
              }
              img:last-child {
                margin-right: 0;
              }
              span {
                // margin-left: 8px;
                max-height: 84px;
                padding: 10px 0;
                text-overflow: clip;
                overflow: hidden;
                width: 169px;
                word-wrap: break-word;
                word-break: normal;
                font-size: 12px;
                max-height: 45px;
              }
            }
          }
          .two_row {
            line-height: 24px;
            text-align: center;
          }
          .state_three_row {
            padding: 18px 0;
          }
          .acceptance {
            padding: 9px 0;
            div {
              height: 12px;
              line-height: 12px;
            }
          }
          .state_two_row {
            padding: 29px 0;
          }
          .com_price {
            font-weight: bold;
          }
          .com_border::after {
            content: "";
            width: 1px;
            height: 50px;
            background: #e8eef5;
            position: absolute;
            right: 0;
          }
          .com_refund {
            color: #5e6066;
          }
          .com_state_box {
            flex-wrap: wrap;
            div {
              width: 100%;
            }
            .chakantui {
              width: 12px;
              height: 12px;
              margin-right: 1px;
            }
            .state_text {
              color: #f75658;
            }
            .com_state_box_info {
              color: #5e6066;
              cursor: pointer;
              &:hover {
                color: #3455d3;
              }
            }
            .extend {
              color: #ced4db;
              &:hover {
                color: #ced4db;
              }
            }
            .com_state_abnormal {
              color: #63cf4e;
            }
            .blue {
              color: #3455d3;
            }
            .com_check {
              width: 66px;
              height: 26px;
              line-height: 26px;
              background: rgba(52, 85, 211, 1);
              border-radius: 2px;
              color: #fff;
              font-weight: bold;
              cursor: pointer;
            }
            .com_dib_check {
              background: #fff;
              border: 1px solid #d1d5dc;
              color: #ced4db;
            }
            .com_pin_check {
              border: 1px solid #909399;
              background: #ffffff;
              color: #2f3133;
            }
            .remaining_time {
              color: #909399;
            }
          }
          .refuse-tips {
            position: absolute;
            right: 29px;
            bottom: 1px;
            color: #b4b7bc;
            font-size: 12px;
          }
        }
      }
    }
  }
  .xing {
    margin-right: 0;
  }
  .two_label {
    // text-align: right;
    text-align: left;
    color: #5e6066;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    // .type_name {
    //   width: 63px;
    // }
    .type_content {
      margin-left: 14px;
      text-align: left;
    }
  }
  .two_label:last-child {
    margin-bottom: 0;
  }
  .markup-t {
    color: #2f3133;
    .order-num {
      font-size: 14px;
      height: 14px;
      line-height: 1;
      margin-bottom: 13px;
      span {
        margin-right: 30px;
      }
    }
    .order-num:last-child {
      margin-bottom: 25px;
    }
    .zhuijia {
      font-size: 14px;
      margin-bottom: 13px;
      .default-input {
        input {
          width: 100%;
        }
      }
    }
  }

  .pay_modes {
    display: flex;
    justify-content: flex-start;
  }
  .zf-tit {
    color: #2f3133;
    font-size: 14px;
    height: 14px;
    line-height: 1;
    margin-bottom: 12px;
  }
  .recharge {
    font-size: 12px;
    color: #5e6066;
    height: 12px;
    line-height: 1;
    margin-top: 6px;
    span {
      color: #3455d3;
      margin-left: 10px;
      .iconfont {
        font-size: 12px;
      }
    }
  }
  .pay_mode {
    width: 134px;
    height: 72px;
    background: rgba(249, 250, 250, 1);
    border-radius: 2px;
    border: 1px solid rgba(206, 212, 219, 1);
    padding: 20px 0 20px 10px;
    display: flex;
    margin-right: 12px;
    cursor: pointer;
    .icon {
      width: 31px;
      height: 31px;
      color: #b4b7bc;
      margin-right: 8px;
    }
  }
  .pay_mode_right {
    height: 32px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #5e6066;
    justify-content: center;
  }
  .yue_money {
    color: #ffad16;
    font-size: 12px;
    margin-top: 6px;
    height: 12px;
    line-height: 1;
  }
  .pay_mode_right:nth-child(1) {
    justify-content: space-between;
    padding: 5px 0;
  }
  .pay_selected {
    background: rgba(243, 245, 253, 1);
    border: 1px solid rgba(52, 85, 211, 1);
    .pay_mode_right {
      color: #2f3133;
    }

    .icon {
      color: #3455d3;
    }
  }
  .pay_mode:hover {
    background: rgba(243, 245, 253, 1);
    border: 1px solid rgba(52, 85, 211, 1);
  }
  .abnormal {
    .type_content {
      img {
        width: 100px;
        height: 100px;
        border-radius: 2px;
        margin-right: 8px;
        margin-top: 8px;
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
.imgs {
  position: relative;
  margin-right: 8px;
  img {
    width: 74px;
    height: 74px;
    &:last-child {
      margin-right: 0;
    }
  }
  .count {
    position: absolute;
    width: 100%;
    height: 24px;
    background: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    bottom: 0;
    left: 0;
  }
}
.remark-add {
  .order_infos {
    height: 106px;
    background: #fff;
    margin-bottom: 10px;
    display: flex;
    padding: 16px 20px;
    // .imgs {
    //   position: relative;
    //   margin-right: 8px;
    //   img {
    //     width: 74px;
    //     height: 74px;
    //     &:last-child {
    //       margin-right: 0;
    //     }
    //   }
    //   .count {
    //     position: absolute;
    //     width: 100%;
    //     height: 24px;
    //     background: rgba(0, 0, 0, 0.5);
    //     font-size: 12px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     color: #ffffff;
    //     bottom: 0;
    //     left: 0;
    //   }
    // }
    .order_data {
      margin-left: 14px;
      & > div {
        display: flex;
        color: #5e6066;
        font-size: 12px;
        line-height: 12px;
        margin-top: 14px;
        &:first-child {
          margin-top: 6px;
        }
      }
    }
    .goorderinfo {
      text-align: right;
      font-size: 12px;
      color: #5e6066;
      flex: auto;

      span:hover {
        cursor: pointer;
        color: #3455d3;
      }
      .iconbiaodan_rili_right {
        font-size: 12px;
        margin-top: 1px;
        display: inline-block;
      }
    }
  }
  textarea {
    height: 130px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    resize: none;
    display: -webkit-box;
    text-align: justify;
    padding-bottom: 20px;
    &:hover,
    &:focus {
      border: 1px solid #dcdfe6;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
